module.exports = __webpack_public_path__ + "img/183.plates_and_cutlery_cleanliness.2a58d2bf.svg";